var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zt-select-item zt-select-item--link relative flex cursor-pointer items-center px-3 tracking-normal no-underline outline-none",class:{
    'zt-select-item--active': _vm.isActive,
    'pl-8': _vm.itemGroup,
  },on:{"click":_vm.handleSelect}},[(_vm.prependIcon)?_c('zt-icon',{staticClass:"mr-2",attrs:{"name":_vm.prependIcon}}):_vm._e(),_c('div',{staticClass:"zt-select-item__content flex flex-wrap items-center self-center overflow-hidden py-3"},[_vm._v("\n    "+_vm._s(_vm.displayText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }